import './_blurb-list.slider.scss';

/**
 * Slider layout for BlurbList.
 */
export default function BlurbListSlider({ children, className = '' }) {
  if (!children) return null;

  return <div className={`BlurbList__slider ${className}`}>{children}</div>;
}
